export default __webpack_public_path__ + "static/media/open-pod-3.8e0d06c5.png";